module.exports = __webpack_public_path__ + "img/light_0_0.efcf6e46.png";